import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"arrow-left\"><defs><style type=\"text/css\"></style></defs><path d=\"M704.412 512l-311.59799999999996-311.598-73.226 73.226L557.441 512 319.588 750.373l73.226 73.226L704.412 512z\" p-id=\"1681\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol